



























































































import { Component, Vue, Prop, ProvideReactive, Ref, Emit, Watch } from 'vue-property-decorator';
import { GQL_currentUnitPaycheckPeriods_currentUnit_paycheckPeriods } from '@/queries/__generated__/currentUnitPaycheckPeriods';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_paycheckDataForPaycheckListForm, GQL_paycheckDataForPaycheckListFormVariables, GQL_paycheckDataForPaycheckListForm_currentUnit, GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts, GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts_paycheckDraftLines, GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations } from '@/queries/__generated__/paycheckDataForPaycheckListForm';
import PaycheckDraftPeriodFormSubUnit from './PaycheckDraftPeriodFormSubUnit.vue';
import PaycheckDraftPeriodFormIrrelevantWorkRelations from './PaycheckDraftPeriodFormIrrelevantWorkRelations.vue';
import { GQL_PaycheckDraftSave, GQL_PaycheckDraftLineSave } from '@/queries/global';
import { GQL_savePaycheckDraftVariables } from '@/queries/__generated__/savePaycheckDraft';
import flattenDeep from 'lodash/flattenDeep';
import { sortBy } from '@/utils/utils';
import { IRules } from '@/components/UI/Form/ValidationModule';
import { validateRequired } from '@/components/UI/Form/Validations';
import SForm from '@/components/UI/Form/SForm.vue';
import { StringBoolean } from './PaycheckDraftPeriodFormWorkRelation.vue';
import paycheckSettingsService from '@/utils/paycheck-settings-service';
import PermissionService from '@/utils/permission-service';
import PaycheckPeriodMarker from './PaycheckPeriodMarker.vue';
import { GQL_paycheckLineTemplates, GQL_paycheckLineTemplates_currentUnit_subUnits_workRelations_paycheckLineTemplates} from '@/queries/__generated__/paycheckLineTemplates';
import gql from 'graphql-tag';

const PAYCHECK_DATA_FOR_PAYCHECK_LIST_FORM = gql`
  query paycheckDataForPaycheckListForm($periodId: ID!) {
    currentUnit {
      id
      subUnits {
        id
        name
        workRelations {
          id
          employee {
            id
            firstName
            lastName
          }
          occupation {
            id
            name
          }
          leaveAndLayoffs: leaveAndLayoffsForPeriod(periodId: $periodId) {
            id
            description
            startDate
            endDate
          }
          startDate
          endDate
          pensionEndDate
          employmentType
          employmentPercentage
          paychecks(periodId: $periodId) {
            id
            number
            lockedAt
            paycheckLines {
              id
              description
              calculationType
              quantity
              rate
              sum
            }
          }
          paycheckDrafts(periodId: $periodId, noPaycheckOnly: true) {
            id
            workRelation { id }
            period { id }
            active
            comment
            paycheck { id }
            savedBy {
              id
              name
            }
            savedAt
            paycheckDraftLines {
              id
              paycheckLineTemplate {
                id
                active
                mainPaycheckLineTemplate {
                  id
                  calculationType
                }
              }
              quantity
              rate
              sum
              car { id }
              project { id }
              department { id }
              carOverwrite
              projectOverwrite
              departmentOverwrite
            }
          }
          lastPaycheck {
            id
            number
            period {
              id
              name
              startDate
              endDate
              journalDate
              bookkeepingPeriod
              isLocked
            }
          }
        }
      }
    }
  }
`;

const SAVE_PAYCHECK_DRAFT = gql`
  mutation savePaycheckDraft($unitId: ID!, $paycheckDrafts: [PaycheckDraftSave!]!) {
    savePaycheckDraft(input: { unitId: $unitId, paycheckDrafts: $paycheckDrafts }) {
      paycheckDrafts {
        id
      }
    }
  }
`;

const PAYCHECK_LINE_TEMPLATES = gql`
  query paycheckLineTemplates {
    currentUnit {
      id
      subUnits {
        id
        workRelations {
          id
          paycheckLineTemplates: activePaycheckLineTemplates {
            id
            active
            quantity
            rate
            sum
            mainPaycheckLineTemplate {
              id
              number
              description
              calculatePositive
              calculationType
            }
            car { id }
            project { id }
            department { id }
            carOverwrite
            projectOverwrite
            departmentOverwrite
          }
        }
      }
    }
  }
`;


export type PaycheckLineTemplateMap = {[workRelationId: string]: GQL_paycheckLineTemplates_currentUnit_subUnits_workRelations_paycheckLineTemplates[]};

@Component({
  components: {
    PaycheckDraftPeriodFormSubUnit,
    PaycheckDraftPeriodFormIrrelevantWorkRelations,
    PaycheckPeriodMarker,
  },
})
export default class PaycheckDraftPeriodForm extends Vue {
  @ProvideReactive()
  @Prop({ type: Object, required: true }) private paycheckPeriod!: GQL_currentUnitPaycheckPeriods_currentUnit_paycheckPeriods;

  @SmartQuery<PaycheckDraftPeriodForm, GQL_paycheckDataForPaycheckListForm, GQL_paycheckDataForPaycheckListFormVariables>({
    query: PAYCHECK_DATA_FOR_PAYCHECK_LIST_FORM,
    variables() { return { periodId: this.paycheckPeriod.id } },
    skip() { return !this.everExpanded },
    fetchPolicy: 'no-cache',
    update: data => ({
      ...data.currentUnit,
      subUnits: data.currentUnit.subUnits.map(subUnit => ({
        ...subUnit,
        workRelations: sortBy(subUnit.workRelations.map(workRelation => ({
          ...workRelation,
          paychecks: workRelation.paychecks
            .sort((paycheck1, paycheck2) => paycheck1.number > paycheck2.number ? -1 : 1)
            .map(paycheck => ({
              ...paycheck,
              paycheckLines: paycheck.paycheckLines.filter(paycheckLine => !paycheckLine.sum.isZero() || !paycheckLine.rate.isZero() || !paycheckLine.quantity.isZero()),
            })),
          paycheckDrafts: workRelation.paycheckDrafts.map(paycheckDraft => ({
            ...paycheckDraft,
            workRelationId: paycheckDraft.workRelation.id,
            periodId: paycheckDraft.period.id,
            paycheckDraftLines: paycheckDraft.paycheckDraftLines
              .map(paycheckDraftLine => ({
                ...paycheckDraftLine,
                paycheckLineTemplateId: paycheckDraftLine.paycheckLineTemplate.id,
                carId: paycheckDraftLine.car?.id,
                projectId: paycheckDraftLine.project?.id,
                departmentId: paycheckDraftLine.department?.id,
              } as GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts_paycheckDraftLines & GQL_PaycheckDraftLineSave)),
          } as GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts & GQL_PaycheckDraftSave)),
        })),
          workRelation => [ [ `${workRelation.employee.firstName} ${workRelation.employee.lastName}`, 'asc' ] ],
        ),
      })),
    }),
    result() {
      this.$nextTick(() => { this.resetFormDirty() });
    },
  }) private currentUnit!: GQL_paycheckDataForPaycheckListForm_currentUnit;

  @SmartQuery<PaycheckDraftPeriodForm, GQL_paycheckLineTemplates>({
    query: PAYCHECK_LINE_TEMPLATES,
    fetchPolicy: 'no-cache',
    update: data => {
      const res: PaycheckLineTemplateMap = {};

      data.currentUnit.subUnits.forEach(subUnit => {
        subUnit.workRelations.forEach(workRelation => {
          res[workRelation.id] = workRelation.paycheckLineTemplates;
        });
      });

      return res;
    },
  })
  @ProvideReactive()
  private paycheckLineTemplatesMap!: PaycheckLineTemplateMap;

  // Expanded state

  public collapse(): void {
    this.expanded = false;
  }

  @Ref() private subUnitRefs!: PaycheckDraftPeriodFormSubUnit[];

  private expanded = paycheckSettingsService.isExpandedSection(this.paycheckPeriod.id);
  private everExpanded = false;
  private undecidedWorkRelationsWarnings: GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations[] = [];

  @Watch('expanded', { immediate: true })
  private onExpandChange(): void {
    if (this.expanded) {
      this.everExpanded = true;
      this.$emit('expanded');
    }

    paycheckSettingsService.expandSection(this.expanded, this.paycheckPeriod.id);
  }

  private expandEmployeesWithNewPaycheckDrafts(): void {
    if (this.subUnitRefs) {
      this.subUnitRefs
        .filter(ref => ref.isExpanded)
        .forEach(ref => setTimeout(() => ref.expandEmployeesWithPaycheckDrafts(true)), 0);
    }
  }

  // Form

  @Ref() private form?: SForm;
  private formValid = true;
  @ProvideReactive() public formDirty = false;

  @ProvideReactive()
  private get editable(): boolean {
    return PermissionService.check('canCreatePaychecks') && !this.paycheckPeriod.isLocked;
  }

  @Emit('update:dirty')
  @Watch('formDirty', { immediate: true })
  private emitIfDirtyChanges(): boolean {
    return this.formDirty;
  }

  private rules = {
    active: [
      {
        validation: ({ dataValue }) => (dataValue as StringBoolean) !== 'null',
        message: i18n => i18n.t('PaycheckDraft.activeMustBeSelected'),
      },
    ],
    paycheckDraftLine: {
      paycheckLineTemplate: [ { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: i18n.t('PaycheckDraft.PaycheckDraftLines.paycheckLineTemplate') }) } ],
      quantity: [],
      rate: [],
      sum: [
        {
          validation: ({ dataValue, formElements, uid }) => {
            if (!formElements.paycheckDraftLine.rate[uid as string]) return true;
            if (!formElements.paycheckDraftLine.quantity[uid as string]) return true;
            if (
              formElements.paycheckDraftLine.rate[uid as string].dataValue.isZero() &&
                formElements.paycheckDraftLine.quantity[uid as string].dataValue.isZero()
            ) return true;

            return (
              formElements.paycheckDraftLine.quantity[uid as string].dataValue
                .times(formElements.paycheckDraftLine.rate[uid as string].dataValue)
                .toDecimalPlaces(2)
                .equals(dataValue)
            );
          },
          message: i18n => i18n.t('PaycheckDraft.PaycheckDraftLines.sumError'),
          triggerBy: [
            ({ withSameUID }) => withSameUID('paycheckDraftLine.rate'),
            ({ withSameUID }) => withSameUID('paycheckDraftLine.quantity'),
          ],
          type: 'warning',
        },
      ],
    },
  } as IRules;

  public resetFormDirty(): void {
    this.form && this.form.resetDirty();
  }

  // Saving

  private saveInProgress = false;

  private formatForMutation(): GQL_savePaycheckDraftVariables {
    return {
      unitId: this.currentUnit.id,
      paycheckDrafts: flattenDeep<GQL_PaycheckDraftSave>(
        this.currentUnit.subUnits.map(subUnit =>
          subUnit.workRelations.map(workRelation =>
            workRelation.paycheckDrafts.map((paycheckDraft: GQL_PaycheckDraftSave) => ({
              id: paycheckDraft.id,
              workRelationId: paycheckDraft.workRelationId,
              periodId: paycheckDraft.periodId,
              active: paycheckDraft.active,
              comment: paycheckDraft.comment,
              paycheckDraftLines: paycheckDraft.paycheckDraftLines!.map(paycheckDraftLine => ({
                id: paycheckDraftLine.id,
                paycheckLineTemplateId: paycheckDraftLine.paycheckLineTemplateId,
                quantity: paycheckDraftLine.quantity,
                rate: paycheckDraftLine.rate,
                sum: paycheckDraftLine.sum,
                carId: paycheckDraftLine.carId,
                projectId: paycheckDraftLine.projectId,
                departmentId: paycheckDraftLine.departmentId,
                carOverwrite: paycheckDraftLine.carOverwrite,
                projectOverwrite: paycheckDraftLine.projectOverwrite,
                departmentOverwrite: paycheckDraftLine.departmentOverwrite,
                _destroy: paycheckDraftLine._destroy || undefined,
              } as GQL_PaycheckDraftLineSave)),
            } as GQL_PaycheckDraftSave)),
          ),
        ),
      ),
    };
  }

  public savePaycheckDrafts(): Promise<boolean> {
    this.expandEmployeesWithNewPaycheckDrafts();
    this.saveInProgress = true;

    return this.$apollo.mutate({
      mutation: SAVE_PAYCHECK_DRAFT,
      variables: this.formatForMutation(),
    }).then(() => {
      this.$sMessage.success(this.$t('Message.saveSuccess'));
      this.$apollo.queries.currentUnit.refetch();
      return true;
    }).catch(() => {
      return false;
    }).finally(() => {
      this.saveInProgress = false;
    });
  }

  private setUndecidedWorkRelationsWarnings() {
    const wrIds = this.undecidedWorkRelationIds;
    const workRelations = this.currentUnit.subUnits.flatMap(subUnit => subUnit.workRelations.filter(wr => wrIds.includes(wr.id)));
    this.undecidedWorkRelationsWarnings = workRelations;
  }

  private get undecidedWorkRelationIds(): string[] {
    if (this.subUnitRefs) {
      return this.subUnitRefs
        .flatMap(ref => {
          if (!ref.workRelationRefs) return [];
          return ref.workRelationRefs
            .filter(r => r.currentPaycheckDraft && r.currentPaycheckDraft.active === null)
            .map(r => r.workRelationId);
        });
    } else {
      return [];
    }
  }
}
